import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getContent } from '../../../../../utilities/getContent/getContent';
import Select from 'react-select';

import * as actions from '../../../../../store/actions';
// import IndicatorSelectFormCategoryGroup from './IndicatorSelectFormCategoryGroup/IndicatorSelectFormCategoryGroup';
import IndicatorSelectFormTypeGroup from './IndicatorSelectFormCategoryGroup/IndicatorSelectFormTypeGroup';

const IndicatorSelectForm = props => {
  const isUK = () => process.env.REACT_APP_STAGE === 'uk';
  const appliedTo = props.surveyCrud.createSurveyObj.appliedTo;
  const [profession, setProfession] = useState(null);
  const setProfessionHandler = (event) => {
    setProfession(event); // the component state
    props.setProfession(event.value); // the redux state
  }

  const hasCustomIndicators = props.surveyCrud.indicators.some( i => i.owner );
  const professionList = props.surveyCrud.professions.map(profession => ({
    label: getContent(profession.professionId),
    value: profession.professionId,
  }));


  return (
    <>
      <div className="content-indicator-select-form">
        {Object.keys(props.surveyCrud.indicatorsByCategoryAndType)
          .sort()
          .map(typeName => {
            return (
                <IndicatorSelectFormTypeGroup
                  key={typeName}
                  typeName={typeName}
                  indicatorsByCategoryAndType={props.surveyCrud.indicatorsByCategoryAndType}
                  indicatorIdsByCategory={props.surveyCrud.indicatorIdsByCategory}
                  chosenIndicators={props.surveyCrud.createSurveyObj.chosenIndicators}
                  toggleCategoryIndicators={props.toggleCategoryIndicators}
                  toggleCheckedIndicatorInForm={props.toggleCheckedIndicatorInForm}
                  appliedTo={props.surveyCrud.createSurveyObj.appliedTo}
                />
            );
          })}

      </div>
      { hasCustomIndicators && <p className='fst-italic'>* denotes indicators specific to your school district or organization.</p> }
      {appliedTo === 'adult' && isUK() === false ? (
        <div className="row mt-5">
          <div className="col-10 content-profession-select-form">
            <div className="dropdown-container">
              <h1 className="indicator-headers">Select profession</h1>
              <Select options={professionList} className="tm-dropdown mr-0" onChange={setProfessionHandler} placeholder="Please select..." value={profession} />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

const mapStateToProps = state => {
  return {
    surveyCrud: state.surveyCrud,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleCheckedIndicatorInForm: indicatorId => dispatch(actions.toggleCheckedIndicatorInForm(indicatorId)),
    setAppliedTo: value => dispatch(actions.setAppliedTo(value)),
    toggleCategoryIndicators: category => dispatch(actions.toggleCategoryIndicators(category)),
    setProfession: profession => dispatch(actions.setProfession(profession)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorSelectForm);
